/** Time range for Letzte Aktionen list (API param `zeitraum`). */
export type LetzteAktionenZeitraum = '30d' | '6m' | 'all';

/** Default window: 1 Monat. */
export const LETZTE_AKTIONEN_ZEITRAUM_DEFAULT: LetzteAktionenZeitraum = '30d';
